import { render } from "./VendorsServices.vue?vue&type=template&id=3dd27664"
import script from "./VendorsServices.vue?vue&type=script&lang=js"
export * from "./VendorsServices.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__